import { trpc } from "@util/trpc/trpcClient.ts";
import React, { useEffect } from "react";

export const RedirectToSatsuma: React.FC = () => {
  const { data: redirectUrl } =
    trpc.satsuma.getSatsumaJWTRedirectUrl.useQuery();

  // Builds a JWT and redirects to Satsuma
  useEffect(() => {
    if (redirectUrl) {
      location.href = redirectUrl;
    }
  }, [redirectUrl]);

  return (
    <div className="flex-center mt-20 flex w-full items-center justify-center">
      Redirecting...
    </div>
  );
};
